import SEO from './composants/SEO';
import { SEO_PAGES } from './donnees/seoPages';
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './PageFAQ.css';
import { useAuth } from './AuthContext';
import Navigation from './composants/Navigation';
import PiedDePage from './composants/PiedDePage';

// ══════════════════════════════════════════════════════════════
// PEFEP Site — PAGE FAQ v3
// - Réponses TOUJOURS dans le DOM (visibles par Google) — on n'anime
//   que l'affichage en CSS (.faq-accord.ouvert .faq-reponse).
// - Contenu à jour : hébergement réel, plans réels, sécurité, domaine.
// - Rubriques ajoutées : Sécurité, Domaine & Hébergement, encart légal.
// ══════════════════════════════════════════════════════════════

export default function PageFAQ() {
  const navigate = useNavigate();
  useAuth();
  const [ouvert, setOuvert] = useState(null);

  const toggle = (i) => setOuvert(ouvert === i ? null : i);

  const faqs = [
    {
      categorie: '🚀 Démarrage',
      questions: [
        {
          q: 'Comment créer mon site avec PEFEP Site ?',
          r: "C'est très simple : créez un compte gratuit, choisissez votre secteur d'activité, répondez aux questions de notre assistant intelligent étape par étape, et l'intelligence artificielle génère votre site automatiquement. Le tout en moins de 30 minutes.",
        },
        {
          q: 'Ai-je besoin de compétences techniques pour utiliser PEFEP Site ?',
          r: "Absolument pas. PEFEP Site a été conçu pour les personnes sans compétences techniques. Si vous savez répondre à des questions simples sur votre activité, vous savez créer votre site.",
        },
        {
          q: 'Combien de temps faut-il pour créer mon site ?',
          r: "En moyenne 20 à 30 minutes pour remplir le questionnaire. Une fois le paiement confirmé, votre site est publié automatiquement, généralement sous 24 heures ouvrables.",
        },
        {
          q: 'Puis-je tester la plateforme avant de payer ?',
          r: "Oui. Vous parcourez tout l'assistant gratuitement et vous voyez un aperçu fidèle de votre site. Le paiement n'est demandé qu'au moment de le publier en ligne.",
        },
      ],
    },
    {
      categorie: '💰 Tarifs & Paiement',
      questions: [
        {
          q: 'Quels moyens de paiement acceptez-vous ?',
          r: "Nous acceptons MonCash, NatCash, PayPal (contact@pefep.site) et le virement bancaire. Après votre paiement, envoyez la confirmation sur WhatsApp au +509 4737 6200 et votre site est publié.",
        },
        {
          q: 'Y a-t-il des frais cachés ?',
          r: "Non, aucun frais caché. Le prix affiché est le prix final. Le seul coût récurrent est le renouvellement annuel de l'hébergement et du domaine, à partir de 50$/an.",
        },
        {
          q: 'Quelle est la différence entre le plan Basique et le plan Complet ?',
          r: "Le plan Basique (≈49$) inclut votre site avec un sous-domaine PEFEP (ex : monsite.pefep.site). Le plan Complet (≈79$) ajoute un domaine .com personnalisé, le SEO de base, un formulaire de contact actif et un support WhatsApp étendu.",
        },
        {
          q: 'Puis-je être remboursé si je ne suis pas satisfait ?',
          r: "Nous tenons à votre satisfaction. Si votre site ne correspond pas à vos attentes, contactez-nous dans les 7 jours suivant la publication : nous ferons le nécessaire pour corriger le problème ou trouver une solution avec vous.",
        },
      ],
    },
    {
      categorie: '🎨 Votre site',
      questions: [
        {
          q: 'Mon site sera-t-il adapté aux téléphones mobiles ?',
          r: "Oui, absolument. Tous les sites générés par PEFEP Site sont automatiquement optimisés pour les téléphones, tablettes et ordinateurs — essentiel vu l'usage massif du mobile en Haïti.",
        },
        {
          q: 'Puis-je modifier mon site après sa création ?',
          r: "Oui. Depuis votre tableau de bord, vous pouvez modifier vos informations, vos produits ou services, vos photos, votre bannière, vos couleurs et vos moyens de paiement — autant de fois que vous le souhaitez, et gratuitement. Vos modifications apparaissent aussitôt en ligne.",
        },
        {
          q: 'Comment est-ce que je reçois les demandes de mes visiteurs ?',
          r: "Chaque commande, inscription, don ou message laissé sur votre site vous parvient par e-mail et par WhatsApp, et s'affiche aussi dans votre tableau de bord « Mes demandes ». Vous ne perdez aucun prospect.",
        },
      ],
    },
    {
      categorie: '🌐 Domaine & Hébergement',
      questions: [
        {
          q: 'Où mes sites sont-ils hébergés ?',
          r: "Vos sites sont hébergés sur une infrastructure cloud professionnelle et sécurisée, avec des serveurs haute disponibilité, des sauvegardes et le HTTPS (certificat SSL) activé sur chaque site. La première année d'hébergement est incluse dans votre offre.",
        },
        {
          q: 'Comment acheter un nom de domaine professionnel (.com) ?',
          r: "Rendez-vous sur notre page Domaines : vérifiez la disponibilité du nom souhaité, et nous nous occupons de l'achat et de la configuration pour vous. Le prix de la première année et du renouvellement sont affichés clairement, sans frais cachés.",
        },
        {
          q: 'Puis-je connecter un nom de domaine que je possède déjà ?',
          r: "Oui. Si vous avez déjà un domaine enregistré ailleurs, nous pouvons l'associer à votre site PEFEP Site. Contactez notre support WhatsApp, il vous accompagne dans la démarche.",
        },
        {
          q: 'Mon site aura-t-il le cadenas de sécurité (HTTPS) ?',
          r: "Oui, chaque site inclut un certificat SSL : votre adresse commence par « https:// ». Cela rassure vos visiteurs et améliore votre référencement Google.",
        },
        {
          q: 'Comment fonctionne le renouvellement ?',
          r: "Votre site reste en ligne un an. À l'approche de l'échéance, vous êtes prévenu et pouvez renouveler l'hébergement (et le domaine) à partir de 50$/an. Une période de grâce est prévue avant toute mise hors ligne.",
        },
      ],
    },
    {
      categorie: '🔐 Sécurité & Confidentialité',
      questions: [
        {
          q: 'Mes données et celles de mes visiteurs sont-elles protégées ?',
          r: "Oui. Vos données sont stockées de façon sécurisée, les mots de passe sont chiffrés, et chaque site utilise le HTTPS. Les demandes laissées par vos visiteurs vous sont réservées et ne sont jamais revendues. Nous suivons les standards internationaux de protection des données — voir notre Politique de confidentialité.",
        },
        {
          q: 'Comment protéger mon compte ?',
          r: "À l'inscription, un mot de passe fort est exigé (au moins 8 caractères, avec majuscule et chiffre). Ne le partagez avec personne et déconnectez-vous sur un appareil partagé. Vous pouvez le modifier à tout moment depuis votre espace.",
        },
        {
          q: 'Qui est responsable des données collectées sur mon site ?',
          r: "C'est vous. Les informations que vos visiteurs laissent sur votre site vous appartiennent et relèvent de votre responsabilité ; PEFEP Site agit comme prestataire technique qui les héberge pour votre compte. Nos Conditions d'utilisation détaillent ce partage des rôles.",
        },
      ],
    },
    {
      categorie: '💻 Développeurs & Agences',
      questions: [
        {
          q: "Je suis développeur ou agence : comment ça marche pour moi ?",
          r: "Vous payez au projet, pas à l'abonnement forcé. Commencez avec 3 sites d'essai gratuits, puis choisissez : À l'unité (≈35$ le projet, avec export HTML autonome), Pack 10 (≈250$, soit 25$ le projet, crédits sans expiration) ou Agency (≈99$/mois, projets illimités + dashboard multi-clients + accès API). Pour l'hébergement et les domaines gérés pour vos clients, l'offre Business Plus est sur mesure.",
        },
        {
          q: 'Puis-je proposer les sites sous ma propre marque ?',
          r: "Des options en marque blanche sont possibles pour les comptes Agency. Écrivez-nous sur WhatsApp au +509 4737 6200 pour définir les modalités adaptées à votre volume.",
        },
        {
          q: 'Y a-t-il une API pour les développeurs ?',
          r: "Oui, l'accès API est inclus dans l'offre Agency : vous pouvez intégrer PEFEP Site à vos propres outils et workflows.",
        },
      ],
    },
    {
      categorie: '📱 Support & Accompagnement',
      questions: [
        {
          q: 'Comment contacter le support PEFEP Site ?',
          r: "Par WhatsApp au +509 4737 6200, par e-mail à contact@pefep.site, ou via le formulaire de contact du site. Nous répondons généralement sous 24 heures ouvrables.",
        },
        {
          q: 'Avez-vous un guide pour préparer mon site ?',
          r: "Oui. Téléchargez gratuitement notre Canvas de Préparation sur la page d'accueil : il vous aide à réunir vos informations, photos et textes avant de commencer, pour un résultat encore plus professionnel.",
        },
        {
          q: 'Que se passe-t-il si mon site rencontre un problème ?',
          r: "Notre équipe surveille l'état des serveurs en continu. En cas de souci, contactez-nous sur WhatsApp et nous intervenons dans les meilleurs délais.",
        },
      ],
    },
  ];

  return (
    <div className="faq-page">
      <SEO {...SEO_PAGES.faq} />
      <Navigation />

      {/* ══ HERO ══ */}
      <section className="faq-hero">
        <div className="faq-hero-content">
          <div className="faq-badge">❓ Questions fréquentes</div>
          <h1>Vous avez des questions ?<br />Nous avons les réponses !</h1>
          <p>Tout ce que vous devez savoir sur PEFEP Site : création, tarifs, domaine, hébergement, sécurité et support.</p>
        </div>
      </section>

      {/* ══ FAQ ACCORDÉON ══ */}
      <section className="faq-content">
        <div className="faq-container">
          {faqs.map((categorie, ci) => (
            <div key={ci} className="faq-categorie">
              <h2 className="faq-categorie-titre">{categorie.categorie}</h2>
              {categorie.questions.map((item, qi) => {
                const index = `${ci}-${qi}`;
                return (
                  <div key={qi} className={`faq-accord ${ouvert === index ? 'ouvert' : ''}`}>
                    <button
                      type="button"
                      className="faq-question"
                      onClick={() => toggle(index)}
                      aria-expanded={ouvert === index}
                    >
                      <span>{item.q}</span>
                      <span className="faq-chevron">{ouvert === index ? '▲' : '▼'}</span>
                    </button>
                    {/* Réponse TOUJOURS rendue (Google la voit) ; l'ouverture
                        n'est qu'un effet CSS via la classe .ouvert du parent. */}
                    <div className="faq-reponse">
                      <p>{item.r}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}

          {/* ══ ENCART LÉGAL ══ */}
          <div className="faq-legal">
            <span className="faq-legal-icone">⚖️</span>
            <p>
              En créant un compte et en utilisant PEFEP Site, vous acceptez nos{' '}
              <Link to="/conditions-d-utilisation">Conditions d'utilisation</Link> et notre{' '}
              <Link to="/politique-de-confidentialite">Politique de confidentialité</Link>.
            </p>
          </div>
        </div>
      </section>

      {/* ══ CONTACT RAPIDE ══ */}
      <section className="faq-contact">
        <div className="faq-container" style={{ textAlign: 'center' }}>
          <h2>Vous n'avez pas trouvé votre réponse ?</h2>
          <p>Notre équipe est disponible pour vous aider personnellement.</p>
          <div className="faq-contact-grid">
            <div className="faq-contact-card">
              <span className="faq-contact-icon">💬</span>
              <h3>WhatsApp</h3>
              <p>Réponse rapide en quelques heures</p>
              <strong>+509 4737 6200</strong>
            </div>
            <div className="faq-contact-card">
              <span className="faq-contact-icon">✉️</span>
              <h3>Email</h3>
              <p>Réponse sous 24 heures ouvrables</p>
              <strong>contact@pefep.site</strong>
            </div>
            <div className="faq-contact-card">
              <span className="faq-contact-icon">📝</span>
              <h3>Formulaire</h3>
              <p>Décrivez votre question en détail</p>
              <button type="button" className="faq-contact-btn" onClick={() => navigate('/contact')}>Nous écrire</button>
            </div>
          </div>
        </div>
      </section>

      {/* ══ CTA ══ */}
      <section className="faq-cta">
        <div className="faq-container" style={{ textAlign: 'center' }}>
          <h2>Prêt à créer votre site ?</h2>
          <p>Rejoignez les organisations haïtiennes qui font confiance à PEFEP Site.</p>
          <button type="button" className="faq-cta-btn" onClick={() => navigate('/connexion')}>
            🚀 Créer mon site maintenant
          </button>
        </div>
      </section>

      <PiedDePage />
    </div>
  );
}